// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ImageRules } from "../ui/types/NewsTypes";
import { message } from "antd";
import i18n from "i18next";

export const getBase64UrlFrom = (base64: string, type: string) => {
  return `data:${type};base64,${base64}`;
};

const removeBase64UrlPrefix = (base64File: any): any => {
  const i = base64File.indexOf("base64,");
  return base64File.slice(i + 7);
};

export const getBase64 = (img: any, callback?: any) => {
  const reader = new FileReader();
  reader.addEventListener("load", () =>
    callback(removeBase64UrlPrefix(reader.result))
  );
  reader.readAsDataURL(img);
};

export const beforeUpload = (file: any, rules?: ImageRules) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error(i18n.t("global.img.error_extension"));
  }
  let maxWeight;
  if (rules?.size) {
    maxWeight = file.size < rules.size;
    if (!maxWeight) {
      message.error(
        i18n.t("global.img.error_size", {
          size: `${Math.floor(rules.size / 1024)} ko`
        })
      );
    }
  } else {
    maxWeight = file.size / 1024 / 1024 < 2;
    if (!maxWeight) {
      message.error(i18n.t("global.img.error_size", { size: "2 MB" }));
    }
  }
  return isJpgOrPng && maxWeight;
};
